export default {
	CONFIRMED: 'Confirmed',
	DECLINED: 'Declined',
	PENDING_CONFIRMATION: 'Pending confirmation',
};
